module.exports = __webpack_public_path__ + "img/lianghuabg.21b5eb13.png";